import { useTranslation } from "@msuite/ui/localization";
import { Panels } from "@msuite/ui/panels";
import { SegmentedControl } from "@msuite/ui/segmented-control";
import { useState } from "react";
import type { ServicePanelBaseProps } from "../shared";
import { ServiceSettingsGeneral } from "./service-settings-general";

type ServiceSettingsTab = "general";

export function ServiceSettings({ serviceId }: ServicePanelBaseProps) {
	/** State */
	const [activeTab, setActiveTab] = useState<ServiceSettingsTab>("general");

	/** Hooks */
	const { t } = useTranslation();

	return (
		<Panels>
			<Panels.Panel flex={1}>
				<SegmentedControl
					value={activeTab}
					orientation="vertical"
					onChange={setActiveTab}
					items={[
						{ value: "general", label: t("general.general"), cyId: "service-settings-general-tab" },
					]}
				/>
			</Panels.Panel>
			<Panels.Panel
				flex={3}
				className="bottom-space"
			>
				{activeTab === "general" && <ServiceSettingsGeneral serviceId={serviceId} />}
			</Panels.Panel>
		</Panels>
	);
}
